import { useEffect, useRef } from 'react'

const STICKY_HEADER_OFFSET_PX = 80

/** Brings the parent element into view when a result appears below the fold. */
export function RevealOnMount() {
  const markerRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    const target = markerRef.current?.parentElement
    if (!target) return
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    target.style.scrollMarginTop = `${STICKY_HEADER_OFFSET_PX}px`
    target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest' })
  }, [])

  return <span ref={markerRef} hidden />
}
